module.exports = "<switch [on]=\"on\" (click)=\"handleClick()\"></switch>"